import type { ContactRow } from "@hub/shared";
import { BUCKET_LABELS } from "@hub/shared";

export function tierLabel(bucket: ContactRow["bucket"]): string {
  return BUCKET_LABELS[bucket];
}

export function tierTone(bucket: ContactRow["bucket"]): "purple" | "info" | "accent" | "neutral" {
  return bucket === 1 ? "purple" : bucket === 2 ? "info" : bucket === 3 ? "accent" : "neutral";
}

export const TIER_COLORS: Record<number, string> = { 1: "var(--tier-closest)", 2: "var(--tier-closer)", 3: "var(--tier-close)" };
